import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './router/AppRouter';
import AppErrorBoundary from './components/AppErrorBoundary';
import { initSentry } from './monitoring/sentry';

// Before render, so an error thrown on the first pass is reported rather than
// being the one that gets lost. A no-op without a DSN in /config.js.
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// The boundary wraps the router and therefore every provider inside it. See
// AppErrorBoundary for why it sits out here rather than within them.
const app = (
  <AppErrorBoundary boundary="root">
    <AppRouter />
  </AppErrorBoundary>
);

root.render(
  IS_LOCALHOST ? <React.StrictMode>{app}</React.StrictMode> : app,
);
